module.exports = __webpack_public_path__ + "static/media/10n.ccc69b99.svg";